import * as selectors from '../selectors';
import { State } from '../state';
import { Dispatch } from 'redux';

export const parseOpenGraph = (urls: string[]) => async (_dispatch: Dispatch, getState: () => State) => {
  const api = selectors.userApi(getState());
  return api.postOpenGraph(urls);
};
